// The Federate role that grants portal admin privileges. Matched exactly (case-insensitive)
// so that unrelated roles which merely contain the substring "admin" (e.g. "admin-requestor",
// "non-admin-viewer", "badminton") do not incorrectly grant admin.
const ADMIN_ROLE = 'admin';

/**
 * Check if the user holds the admin role.
 * @param roles - Array of user roles from the federate token
 * @returns true if any role equals the admin role (case-insensitive)
 */
export const isAdminUser = (roles: string[]): boolean => {
  return roles.some((role) => role.toLowerCase() === ADMIN_ROLE);
};

/**
 * Landing page for a user without the admin role. The Content Connection pages (Overview,
 * Collections, Applications) are admin-only, so a non-admin lands on Media Processing in the
 * global region and on the HTML Editor elsewhere (Media Processing is global-only).
 */
export const nonAdminHome = (region: string): string => (region === 'global' ? '/' : '/html-editor');
